<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules">
    <div class="toggles">
      <div
        class="row justify-content-center mb-n3"
        :class="`row-cols-2 row-cols-md-${inRow}`"
      >
        <div v-for="(item, index) in options" :key="item" class="col">
          <label
            class="btn btn-toggle mb-3"
            :class="{
              active:
                item === value || (Array.isArray(value) && value.includes(item))
            }"
          >
            <input
              v-if="type === 'radio'"
              :id="`${id}-${index}`"
              v-model="current"
              :vid="id"
              type="radio"
              :name="name"
              v-bind="$attrs"
              :value="item"
            />
            <input
              v-else
              :id="`${id}-${index}`"
              v-model="current"
              :vid="id"
              type="checkbox"
              :name="name"
              v-bind="$attrs"
              :value="item"
            />
            {{ item }}
          </label>
        </div>
      </div>
      <span class="invalid-feedback">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line
        return `vue-input-${this._uid}`;
      }
    },
    rules: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Array],
      default: () => []
    },
    inRow: {
      type: Number,
      default: 3
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      defualt: false
    }
  },

  data() {
    return {
      current: this.value
    }
  },

  computed: {
    type() {
      if (this.multiple) {
        return "checkbox"
      }

      return "radio"
    }
  },

  watch: {
    current(value) {
      this.$emit("input", value)
    }
  }
}
</script>
